// extracted by mini-css-extract-plugin
module.exports = {"fullScreenCenter":"styles_fullScreenCenter__7HRbN","infoBox":"styles_infoBox__3oh8R","content":"styles_content__21qZY"};